import { Radio, Select, Spin } from 'antd';
import ErrorMessage from '../ErrorMessage';
import { useUiData } from '../../lib/hooks';
const uiKeys = ['ageGroups'];
const AgeGroupPicker = ({
  ages,
  selected,
  mode = "radio",
  includeOverall = true,
  onChange
}) => {
  const {
    isPending,
    isError,
    data
  } = useUiData(uiKeys);
  if (isPending) {
    return <Spin size="small" />;
  }
  if (isError) {
    return <ErrorMessage message="There was an error during loading app data. Reload the page to try again." />;
  }
  const agesList = data.ageGroups.filter(age => ages === undefined || ages.includes(age.id));
  if (includeOverall && agesList.length > 1) {
    agesList.unshift({
      id: undefined,
      name: mode === 'dropdown' ? 'Any Age' : 'Overall'
    });
  }
  if (['dropdown', 'multi'].includes(mode)) {
    return <Select value={selected} onChange={onChange} mode={mode === 'multi' ? 'multiple' : null}>
				{agesList.map(age => <Select.Option value={age.id} key={age.name}>{age.name}</Select.Option>)}
			</Select>;
  }
  return <>
			Age Groups:
			{' '}
			<Radio.Group size="default" buttonStyle="solid" onChange={e => onChange(e.target.value)} options={agesList.map(age => ({
      label: age.name,
      value: age.id
    }))} optionType="button" buttonStyle="solid" value={selected} data-sentry-element="unknown" data-sentry-source-file="AgeGroupPicker.jsx" />
			{' '}
		</>;
};
export default AgeGroupPicker;